import React from 'react';
import { SvgIcon } from '../../common/SvgIcon';
import { simpleIconPropsTypes } from '../propTypes';

export const IconExport = (props) => {
  const { width = 18, height = 18 } = props;

  return (
    <SvgIcon width={width} height={height} viewBox="0 0 18 18">
      <path
        d="M10.4 6c.552 0 1 .448 1 1 0 .513-.386.936-.883.993L10.4 8H6.6c-.298 0-.546.218-.592.503L6 8.6v8.8c0 .298.218.546.503.592L6.6 18h8.8c.298 0 .546-.218.592-.503L16 17.4v-3.8c0-.552.448-1 1-1 .513 0 .936.386.993.883L18 13.6v3.8c0 1.38-1.076 2.51-2.436 2.595L15.4 20H6.6c-1.38 0-2.51-1.076-2.595-2.436L4 17.4V8.6c0-1.38 1.076-2.51 2.436-2.595L6.6 6h3.8zM19 4h.02c.023 0 .046.002.07.004L19 4c.05 0 .1.004.149.011l.052.01c.022.004.043.009.065.015l.046.014.06.021.051.023.061.03.037.022c.025.016.05.032.074.05l.022.017c.063.05.12.107.17.17l-.08-.09c.036.035.068.073.097.112.018.024.034.049.05.074l.021.037c.011.02.022.04.031.06l.023.053.021.06.014.045.016.065.009.053.004.031.003.03.003.055L20 5v5c0 .552-.448 1-1 1-.513 0-.936-.386-.993-.883L18 10V7.414l-7.293 7.293c-.39.39-1.024.39-1.414 0-.36-.36-.388-.928-.083-1.32l.083-.094L16.584 6H14c-.513 0-.936-.386-.993-.883L13 5c0-.513.386-.936.883-.993L14 4h5z"
        transform="translate(-3 -3)"
      />
    </SvgIcon>
  );
};

export const IconExportButton = <IconExport width={16} height={16} />;

IconExport.propTypes = simpleIconPropsTypes;
